export const useFeaturesStore = defineStore('features', {
  state: () => ({
    features: null as PaginatedFeature | null,
  }),
  getters: {
    getFeatures: (state) => (state.features !== null ? state.features.items : []),
  },
  actions: {
    setFeatures(features: PaginatedFeature) {
      useLocalStorage().setItem('features', features);
      this.features = features;
    },
    async createFeature(feature: FeatureCreateUpdate): Promise<Feature | undefined> {
      try {
        const {data} = await apiPostFeature(feature);
        pushDataToPaginatedState(this.features, data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readFeatures({
      offset,
      limit,
      search,
    }: {offset?: number; limit?: number; search?: string} = {}): Promise<
      PaginatedFeature | undefined
    > {
      // Parse the local storage value & set the state.
      const localStorageFeatures: PaginatedFeature | null = useLocalStorage().getItem('features');
      if (localStorageFeatures) this.setFeatures(localStorageFeatures);
      try {
        const {data} = await apiGetFeatures(limit, offset, search);
        this.setFeatures(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readFeatureById(id: string | number): Promise<Feature | undefined> {
      // Parse & return the local storage value.
      const localStorageFeatures: PaginatedFeature | null = useLocalStorage().getItem('features');
      if (localStorageFeatures) {
        const foundFeature = localStorageFeatures.items.find((c) => c.id === id);
        if (foundFeature !== undefined) return foundFeature;
      }
      try {
        const {data} = await apiGetFeature(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateFeature(feature: FeatureCreateUpdate): Promise<Feature | undefined> {
      try {
        const response = await apiPutFeature(feature);
        const data: Feature = response.data;
        // Find & update the target object.
        if (this.features !== null) {
          const index = this.features.items.findIndex((p) => p.id === data.id);
          if (index >= 0) {
            Object.assign(this.features.items[index], data);
            useLocalStorage().setItem('features', this.features);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteFeature(id: string | number) {
      try {
        await apiDeleteFeature(id);
        // Find & remove the element.
        if (this.features !== null) {
          const index = this.features.items.findIndex((p) => p.id === id);
          if (index >= 0) {
            this.features.items.splice(index, 1);
            useLocalStorage().setItem('features', this.features);
          }
          this.features.total -= 1;
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
